module.exports = __webpack_public_path__ + "media/CN_002.e6d970d9.mp3";